import { ReactElement } from 'react';
import { SectionWrap, SummarySectionContent, TitleWrap } from './styles';

interface SummarySectionProps {
    title: string;
    colorScheme: 'teal' | 'pink' | 'purple';
    id: string;
    children: ReactElement;
}

const SummarySection = (props: SummarySectionProps) => {
    const { id, title, colorScheme, children } = props;

    return (
        <SectionWrap id={id}>
            <TitleWrap colorScheme={colorScheme}>
                <h2>{title}</h2>
            </TitleWrap>
            <SummarySectionContent>{children}</SummarySectionContent>
        </SectionWrap>
    );
};

export default SummarySection;
